"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsStoreRestApi = void 0;
const lodash_1 = __importDefault(require("lodash"));
const ICCanisterUtils_1 = require("src/hello_assets/src/util/ICCanisterUtils");
const isAnyProjectAnalytics = async (analyticsStoreActors, accessToken) => {
    // console.log("AnalyticsStoreRestApi.isAnyProjectAnalytics: start with", {analyticsStoreActors, accessToken});
    const promises = [];
    lodash_1.default.each(analyticsStoreActors, analyticsStoreActor => promises.push(analyticsStoreActor.isAnyProjectAnalytics(accessToken)));
    const result = await Promise.all(promises);
    // console.log("AnalyticsStoreRestApi.isAnyProjectAnalytics: result", result);
    return lodash_1.default.some(result, (v, idx) => {
        if ((0, ICCanisterUtils_1.isICRequestOk)(v)) {
            // console.log(`AnalyticsStoreRestApi.isAnyProjectAnalytics: result`, v.ok, analyticsStoreActors[idx]);
            return v.ok;
        }
        else if ((0, ICCanisterUtils_1.isICRequestErr)(v)) {
            const errorName = (0, ICCanisterUtils_1.getICFirstKey)(v.err);
            // console.log(`AnalyticsStoreRestApi.isAnyProjectAnalytics: error`, errorName, analyticsStoreActors[idx]);
            throw new Error(errorName);
        }
        throw new Error("unknown");
    });
};
const getProjectDashboardChunk = async (actor, accessToken, parameters) => {
    return await actor.getProjectDashboardChunk(accessToken, parameters);
};
const getProjectRetentionChunkNew = async (actor, accessToken, cohortQuery, returnQuery, parameters) => {
    return await actor.getProjectRetentionChunkNew(accessToken, cohortQuery, returnQuery, parameters);
};
const getProjectStickinessChunkNew = async (actor, accessToken, cohortQuery, returnQuery, parameters) => {
    return await actor.getProjectStickinessChunkNew(accessToken, cohortQuery, returnQuery, parameters);
};
const getProjectLifecycleChunkDay = async (actor, accessToken, parameters) => {
    return await actor.getProjectLifecycleChunkDay(accessToken, parameters);
};
const getProjectLifecycleChunkWeek = async (actor, accessToken, parameters) => {
    return await actor.getProjectLifecycleChunkWeek(accessToken, parameters);
};
const getProjectLifecycleChunkMonth = async (actor, accessToken, parameters) => {
    return await actor.getProjectLifecycleChunkMonth(accessToken, parameters);
};
const getProjectFunnelChunkDay = async (actor, accessToken, returnEvents, periodType, queryPartitionRange) => {
    return await actor.getProjectFunnelChunkDay(accessToken, returnEvents, periodType, queryPartitionRange);
};
exports.AnalyticsStoreRestApi = {
    isAnyProjectAnalytics: isAnyProjectAnalytics,
    getProjectDashboardChunk: getProjectDashboardChunk,
    getProjectRetentionChunkNew: getProjectRetentionChunkNew,
    getProjectStickinessChunkNew: getProjectStickinessChunkNew,
    getProjectLifecycleChunkDay: getProjectLifecycleChunkDay,
    getProjectLifecycleChunkWeek: getProjectLifecycleChunkWeek,
    getProjectLifecycleChunkMonth: getProjectLifecycleChunkMonth,
    getProjectFunnelChunkDay: getProjectFunnelChunkDay,
};
